import React, { createRef, Component, Children } from 'react'
import { gsap } from 'gsap'

import viewport from 'services/viewport'
import scroll from 'services/scroll'

const lerp = (start, end, amt) => {
  return (1 - amt) * start + amt * end
}

const clamp = (val, min, max) => {
  return Math.min(Math.max(val, min), max)
}

const DEFAULT_SCROLL_EASING = 0.12

export default class Elevator extends Component {
  ref = createRef()

  constructor(props) {
    super(props)

    this.easing = props.easing || DEFAULT_SCROLL_EASING
    this.perc = 0
    this.targetPerc = 0
    this.updateTl()
  }

  componentDidMount() {
    this.onResize()

    gsap.ticker.add(this.raf)
    viewport.on('resize', this.onResize)
  }

  componentDidUpdate() {
    this.updateTl()
  }

  componentWillUnmount() {
    gsap.ticker.remove(this.raf)
    viewport.off('resize', this.onResize)
  }

  getChildRef() {
    const childElement = Children.only(this.props.children)
    
return childElement.ref || this.ref
  }

  updateTl() {
    this.tl = this.props.tl ? [].concat(this.props.tl) : []
  }

  onResize = () => {
    const { offset, offsetBottom } = this.props

    const childRef = this.getChildRef()
    const rect = childRef.current.getBoundingClientRect()

    this.offsetY = rect.top + scroll.getScrollTop() - offset * viewport.height
    this.height =
      rect.height + offset * viewport.height + offsetBottom * viewport.height

    this.resizing = true
  }

  raf = () => {
    this.targetPerc = clamp(
      (scroll.y - this.offsetY + viewport.height) /
        (viewport.height + this.height),
      0,
      1
    )

    this.perc = this.resizing
      ? this.targetPerc
      : lerp(this.perc, this.targetPerc, this.easing)
    this.perc = Math.round(this.perc * 10000) / 10000
    this.resizing = false

    if (!this.props.forceUpdate && (this.perc > 0.999 || this.perc < 0.001)) {
      return
    }
    this.tl.forEach((tl) => tl.progress(this.perc))
    this.props.onProgress && this.props.onProgress(this.perc, this.props.id)
  }

  render() {
    const { children } = this.props
    const childElement = Children.only(children)
    
return React.cloneElement(childElement, {
      ref: this.getChildRef(),
    })
  }
}

Elevator.defaultProps = {
  offset: 0,
  offsetBottom: 0,
}
